module.exports = __webpack_public_path__ + "img/logo2.f91ef54e.png";